import { useMutation } from '@tanstack/react-query';
import { linkDestination, unlinkDestination } from '_/api/flows/flowSegments.api';
import { notification } from 'antd';
import React, { ReactElement, useCallback } from 'react';

import { IFlowDestinationsLinkerProps } from './FlowDestinations.types';
import FlowDestinationsCheckbox from './FlowDestinationsCheckbox';

const FlowDestinationsLinker = ({
  destinationId,
  flowDestinationId,
  flowSegmentId,
  overrideDestinations = true,
}: IFlowDestinationsLinkerProps): ReactElement => {
  const checked = flowSegmentId ? !!flowDestinationId : true;
  const disabled = !flowSegmentId || !overrideDestinations;

  // Mutation for linking destination
  const { mutate: linkMutate } = useMutation({
    mutationFn: async () => {
      return linkDestination(flowSegmentId, destinationId);
    },
    onSuccess: () => {
      notification.success({
        message: 'Destination linked',
      });
      // Reload the page to refresh the destinations list
      window.location.reload();
    },
    onError: (error: any) => {
      console.error('flowDestinationLinkSaga error', error);
      notification.error({
        message: 'Destination linking to the Flow failed',
      });
    },
  });

  // Mutation for unlinking destination
  const { mutate: unlinkMutate } = useMutation({
    mutationFn: async () => {
      return unlinkDestination(flowSegmentId, destinationId);
    },
    onSuccess: () => {
      notification.success({
        message: 'Destination unlinked',
      });
      // Reload the page to refresh the destinations list
      window.location.reload();
    },
    onError: (error: any) => {
      console.error('flowDestinationUnlinkSaga error', error);
      notification.error({
        message: 'Destination unlinking failed',
      });
    },
  });

  const onChange = useCallback(() => {
    if (flowDestinationId) {
      unlinkMutate();
    } else {
      linkMutate();
    }
  }, [flowDestinationId, linkMutate, unlinkMutate]);

  const tooltip = disabled
    ? ''
    : `Click to ${flowDestinationId ? 'exclude destination from' : 'include destination to'} custom flow destinations list`;

  return <FlowDestinationsCheckbox checked={checked} disabled={disabled} onChange={onChange} tooltip={tooltip} />;
};

export default FlowDestinationsLinker;
